import React, { useContext } from 'react';
import './ArticlesBar.module.scss';
import { QuizContext } from 'screens/Quiz/Quiz';
import resultsData from '../../ResultData';
import ArticleCard from './ArticleCard/ArticleCard';

export default function ArticlesBar() {
    const { answers } = useContext(QuizContext);
    const answersArray = Object.values(answers);

    const articles = resultsData.filter((article) =>
        article.tags.some((tag) => answersArray.includes(tag))
    );

    return (
        <div styleName="articles-bar">
            {articles.length !== 0 ? (
                <>
                    {articles.map((article, i) => (
                        <ArticleCard article={article} index={i} key={i} />
                    ))}
                </>
            ) : (
                <p styleName="no-articles">
                    Er zijn op dit moment geen artikelen die passen bij jouw
                    keuzes. Maar wanneer je contact met me opneemt gaan we
                    opzoek naar een passende match.
                </p>
            )}
        </div>
    );
}
